export const JOB_STAGES = {
    SOURCED: 'Sourced',
    APPLIED:   'Applied',
    SCREENING:   'Screening',
    INTERVIEW: 'Interview',
    OFFERED:   'Offered',
    HIRED: 'Hired',
 }